import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=bfb88224"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfb88224')) {
      api.createRecord('bfb88224', component.options)
    } else {
      api.reload('bfb88224', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=bfb88224", function () {
      api.rerender('bfb88224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/lesson/Index.vue"
export default component.exports